// extracted by mini-css-extract-plugin
export default {"main":"JoinCommunity_main__4apYP","content":"JoinCommunity_content__4XnfE","btn":"JoinCommunity_btn__YMI6k"};